import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "inputRef", "onKeyDown", "aria-describedby", "placeholder"];
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { textInputStyle, textInputProps, textInputReset } from './textInputStyle';
import { useFormFieldContext } from 'components/FormField';
var shouldForwardProp = function shouldForwardProp(prop) {
  return !textInputProps.includes(prop);
};
export var StyledInput = styled.input.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "TextInput__StyledInput",
  componentId: "sc-11gwy7p-0"
})(["", " &[type='password']::-ms-clear,&[type='password']::-ms-reveal{display:none;}"], textInputStyle);
var TextInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    inputRef = _ref.inputRef,
    onKeyDown = _ref.onKeyDown,
    ariaDescribedBy = _ref['aria-describedby'],
    placeholder = _ref.placeholder,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useFormFieldContext = useFormFieldContext({
      id: otherProps.id,
      required: otherProps.required,
      descriptionIds: ariaDescribedBy
    }),
    id = _useFormFieldContext.id,
    required = _useFormFieldContext.required,
    horizontal = _useFormFieldContext.horizontal,
    descriptionIds = _useFormFieldContext.descriptionIds;
  return /*#__PURE__*/React.createElement(StyledInput, _extends({}, otherProps, {
    ref: ref || inputRef,
    type: type || 'text',
    id: id,
    required: required,
    "aria-describedby": descriptionIds
    // Safari has a [bug](https://bugs.webkit.org/show_bug.cgi?id=142968) where
    // empty input fields do not align correctly with baseline alignment.
    // Adding a "one space" placeholder fixes the issue.
    ,
    placeholder: horizontal ? placeholder || ' ' : placeholder,
    onKeyDown: onKeyDown
  }));
});
TextInput.displayName = 'TextInput';
export { textInputStyle, textInputProps, textInputReset };
export default TextInput;